import React from "react"
import styled from "styled-components"
import Scrollbar from "react-scrollbars-custom"

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-right: 8px;
`

const LinksHolder = ({ children, onScrollFrame }) => {
  return (
    <Scrollbar
      style={{ height: "500px" }}
      trackYVisible={true}
      trackYTrackOnHover={true}
      onScroll={onScrollFrame}
      trackYProps={{
        renderer: props => {
          const { elementRef, style, ...restProps } = props
          return (
            <div
              {...restProps}
              ref={elementRef}
              style={{
                ...style,
                borderRadius: "3px",
                width: "6px",
                right: "2px",
              }}
            />
          )
        },
      }}
      thumbYProps={{
        renderer: props => {
          const { elementRef, style, ...restProps } = props
          return (
            <div
              {...restProps}
              ref={elementRef}
              style={{
                ...style,
                backgroundColor: "rgba(0, 0, 0, 0.4)",
                borderRadius: "3px",
              }}
            />
          )
        },
      }}
    >
      <ContentContainer>{children}</ContentContainer>
    </Scrollbar>
  )
}

export default LinksHolder
